import { CUSTOMER_EXTERNAL_REFERENCE_KEY, CustomerType } from "../constants.js";
import { getCustomerByExternalReference } from "../services/getCustomerByExternalReference.js";
import { getCustomerByIdentifier } from "../services/getCustomerByIdentifier.js";
export const getCustomer = ({ key, customerType }, { client }) => {
    if (customerType === CustomerType.INDIVIDUAL) {
        return getCustomerByExternalReference({ value: key, key: CUSTOMER_EXTERNAL_REFERENCE_KEY.PHONE }, { client });
    }
    else {
        return getCustomerByIdentifier({ customerIdentifier: key }, { client });
    }
};
